module.exports = __webpack_public_path__ + "static/img/YB-120V.4be4b8ad.png";